import React from 'react';
import SimpleHero from '../components/SimpleHero/SimpleHero';
import PageHero from '../components/Minimal/PageHero';
import FeatureList from '../components/Minimal/FeatureList';
import hidden from "../assets/images/hidden.png";
import hidden3 from "../assets/images/mobile-banking.png";
import hiddens from "../assets/images/piggy-bank.png";
import savingsImg from "../assets/images/saving.png";

const BusinessSavings = () => {
  return (
    <div>
      <SimpleHero
        title="Save smarter for your business"
        subtitle="Competitive rates. No monthly fees. Simple tools to grow your cash."
        primaryLabel="View rates"
        primaryHref="/cd"
        variant="sofi"
        imageSrc={savingsImg}
        imageAlt="Business savings preview"
        imageOn="right"
        tiltImage
        badges={["Competitive yield","No monthly fees","Mobile access"]}
      />
      <FeatureList
        items={[
          { icon: hidden, title: 'No monthly fees', desc: 'Keep more in your account with no surprises.' },
          { icon: hiddens, title: 'Competitive yields', desc: 'Earn more with our business savings.' },
          { icon: hidden3, title: 'Mobile access', desc: 'Manage balances and transfers anywhere.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <a className="btn btn-gn-primary" href="/DirectDeposit">Open business savings</a>
        </div>
      </section>
    </div>
  );
};

export default BusinessSavings;
